import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdminProfileService {
  constructor(private readonly http: HttpClient) {}

  getProfiles(): Observable<Profile[]> {
    return this.http.post<ProfilResponse>('profil/get', { data: {} }).pipe(map((response) => response.items));
  }
}

type ProfilResponse = {
  status: {
    code: string;
    message: string;
  };
  items: Array<Profile>;
  count: number;
  hasError: false;
};

export type Profile = { id: number; code: string; libelle: string };
